import { type FC } from "react";
import { type DropdownItem, MultiStateButton } from "components/buttons/multiStateButton/MultiStateButton";
import BasicLinkButton from "components/buttons/linkButtons/baseLinkButton/BasicLinkButton";
import EnvelopeBan from "images/envelope-ban.svg?react";
import { useFeatureFlag } from "../../../../hooks/useFeatureFlag";
import { FeatureFlags } from "../../../../featureFlags";

interface BlackListButtonProps {
  selectedUsers: number[];
  onAddToBlackList: (selectedUsers: number[]) => void;
  onRemoveFromBlackList: (selectedUsers: number[]) => void;
}

const BlackListButton: FC<BlackListButtonProps> = ({ selectedUsers, onAddToBlackList, onRemoveFromBlackList }) => {
  const blackListEnabled = useFeatureFlag(FeatureFlags.BlackList);

  if (selectedUsers.length === 0 || !blackListEnabled) return null;

  const options: DropdownItem[] = [
    {
      text: "Add to List",
      icon: "far fa-plus-circle",
      onClick: () => onAddToBlackList(selectedUsers),
    },
    {
      text: "Remove from List",
      icon: "far fa-minus-circle",
      onClick: () => onRemoveFromBlackList(selectedUsers),
    },
  ];

  return (
    <MultiStateButton
      id="blacklist-button"
      simple
      isLinkStyle
      items={options}
      trigger={<BasicLinkButton text="No Contact List" svg={<EnvelopeBan />} />}
    />
  );
};

export default BlackListButton;
